


































































import { Vue, Prop, Component } from "vue-property-decorator";
import { Widget as IWidget } from "@/api/models/widget";

@Component({ components: {} })
export default class ApiTableItem extends Vue {
  @Prop() widget!: IWidget;
  data() {
    return {};
  }

  get screenWidth() {
    return window.innerWidth;
  }
}
